var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as Sentry from "@sentry/browser";
import { SentryProvider } from "../sentry.provider";
import { LongAnimationFramePerformanceSentry } from "./performance/long-animation-frame.performance.sentry";
import { MarkPerformanceSentry } from "./performance/mark.performance.sentry";
import { NavigationPerformanceSentry } from "./performance/navigation.performance.sentry";
import { PageLoadPerformanceSentry } from "./performance/pageload.performance.sentry";
import { PaintPerformanceSentry } from "./performance/paint.performance.sentry";
import { ResourcePerformanceSentry } from "./performance/resource.performance.sentry";
var PerformanceSentry = /** @class */ (function () {
    function PerformanceSentry(platform) {
        this.platform = platform;
    }
    PerformanceSentry.parseMillisecondsToSeconds = function (milliseconds) {
        return milliseconds / 1000;
    };
    PerformanceSentry.prototype.capturePageLoad = function () {
        var _this = this;
        try {
            Sentry.startNewTrace(function () {
                var _a, e_1, _b, e_2, _c;
                var now = performance.now();
                var parentSpanStartTime = _this.getDocumentFinishedAt();
                var parentSpan = Sentry.startInactiveSpan({
                    op: "pageload",
                    name: "Page Load - ".concat(_this.platform),
                    attributes: (_a = {},
                        _a[Sentry.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "url",
                        _a),
                    startTime: PerformanceSentry.parseMillisecondsToSeconds(parentSpanStartTime),
                });
                try {
                    for (var _d = __values(SentryProvider.getTagsEntries()), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var _f = __read(_e.value, 2), key = _f[0], value = _f[1];
                        parentSpan.setAttribute("data.".concat(key), value);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                new PageLoadPerformanceSentry(parentSpanStartTime, parentSpanStartTime + _this.getFirstNavigation().responseEnd, parentSpan).generateSpan();
                try {
                    for (var _g = __values(performance.getEntries()), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var entry = _h.value;
                        /**
                         * Ignore visibility-state (active/inactive tab)
                         */
                        if (entry.entryType === "visibility-state")
                            continue;
                        _this.createSpanForEntry(parentSpan, parentSpanStartTime, entry);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                parentSpan.end(PerformanceSentry.parseMillisecondsToSeconds(window.performance.timeOrigin + now));
            });
        }
        catch (e) {
            console.error(e);
        }
    };
    PerformanceSentry.prototype.captureAction = function (performanceSince) {
        var _this = this;
        try {
            Sentry.startNewTrace(function () {
                var e_3, _a, e_4, _b;
                var now = performance.now();
                var parentSpanStartTime = _this.getDocumentFinishedAt();
                var parentSpan = Sentry.startInactiveSpan({
                    op: "action",
                    name: "Action - ".concat(_this.platform),
                    startTime: PerformanceSentry.parseMillisecondsToSeconds(window.performance.timeOrigin + performanceSince),
                });
                try {
                    for (var _c = __values(SentryProvider.getTagsEntries()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
                        parentSpan.setAttribute("data.".concat(key), value);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                try {
                    for (var _f = __values(performance.getEntries()), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var entry = _g.value;
                        if (entry.startTime < performanceSince || entry.startTime > now)
                            continue;
                        /**
                         * Ignore visibility-state (active/inactive tab)
                         */
                        if (entry.entryType === "visibility-state")
                            continue;
                        _this.createSpanForEntry(parentSpan, parentSpanStartTime, entry);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                parentSpan.end(PerformanceSentry.parseMillisecondsToSeconds(window.performance.timeOrigin + now));
            });
        }
        catch (e) {
            console.error(e);
        }
    };
    /**
     * TODO later
     * @param performanceSince
     */
    PerformanceSentry.prototype.captureNavigation = function (performanceSince) {
        try {
            var performanceNow = performance.now();
            console.log("PerformanceSentry", "captureNavigation", performanceSince, performanceNow);
        }
        catch (e) {
            console.error(e);
        }
    };
    PerformanceSentry.prototype.getDocumentStartedAt = function () {
        return window.performance.timeOrigin;
    };
    PerformanceSentry.prototype.getDocumentFinishedAt = function () {
        return this.getDocumentStartedAt() + this.getFirstNavigation().connectStart;
    };
    PerformanceSentry.prototype.getFirstNavigation = function () {
        return performance.getEntriesByType("navigation")[0];
    };
    PerformanceSentry.prototype.createSpanForEntry = function (parentSpan, startTime, entry) {
        if (entry instanceof PerformanceNavigationTiming)
            return new NavigationPerformanceSentry(entry).generateSpan();
        if (entry instanceof PerformancePaintTiming)
            return new PaintPerformanceSentry(entry, startTime, parentSpan).generateSpan();
        if (entry instanceof PerformanceMark && entry.name === "sentry-tracing-init")
            return new MarkPerformanceSentry(entry, startTime, parentSpan).generateSpan();
        if (entry instanceof PerformanceResourceTiming)
            return new ResourcePerformanceSentry(entry, startTime, parentSpan).generateSpan();
        if (entry.entryType === "long-animation-frame")
            return new LongAnimationFramePerformanceSentry(entry, startTime, parentSpan).generateSpan();
        // Disabled for now (because it has for example measure
        // https://lemonero.sentry.io/performance/trace/226c006120864bbb8070a29ffbe07627/?node=span-b3595a0e2fed42b8&node=txn-782db94c295b46bf83d40dc92e867c92&pageEnd&pageStart&project=4505086503092224&source=traces&statsPeriod=24h&timestamp=1727316507.598
        // const event = Sentry.startInactiveSpan({
        // 	op: `${entry.entryType}`,
        // 	name: `${entry.name}`,
        // 	startTime: PerformanceSentry.parseMillisecondsToSeconds(startTime + entry.startTime),
        // 	parentSpan: parentSpan,
        // })
        // event.end(PerformanceSentry.parseMillisecondsToSeconds(startTime + entry.startTime + Math.abs(entry.duration)))
    };
    return PerformanceSentry;
}());
export { PerformanceSentry };
//# sourceMappingURL=performance.sentry.js.map